import {
  GET_UO_LIST,
  GET_AVAILABLE_SLOTS,
  GET_PRENOTAZIONE,
  GET_PRENOTAZIONI_LIST,
  GET_BOOKING_SCHEMA,
  // RESET_BOOKING_SCHEMA,
  ADD_BOOKING,
  RESET_PRENOTAZIONE,
  GET_VOC_ORE,
  GET_VOC_BOOKING_TYPES,
  MOVE_BOOKING,
  RESET_MOVE_BOOKING,
  ADD_VACATION,
  RESET_ADD_VACATION,
  DELETE_BOOKING,
  RESET_DELETE,
  BOOKING_REMINDER,
  BOOKING_RESET_REMINDER,
  UPDATE_BOOKING,
  RESET_UPDATE_BOOKING,
} from '@redturtle/volto-io-prenoto/actions/booking';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
};

// Get UO List
export const listUO = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UO_LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_UO_LIST}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_UO_LIST}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Get Prenotazioni List
export const prenotazioniList = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_PRENOTAZIONI_LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_PRENOTAZIONI_LIST}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_PRENOTAZIONI_LIST}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Get availableSlots
export const availableSlots = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_AVAILABLE_SLOTS}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
        result: {},
      };
    case `${GET_AVAILABLE_SLOTS}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_AVAILABLE_SLOTS}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    default:
      return state;
  }
};

// Get prenotazione schema
export const bookingSchema = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_BOOKING_SCHEMA}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_BOOKING_SCHEMA}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...action.result,
          fields: action.result.fields.filter((f) => f.name !== 'description'), //remove description field because managed separately
          date: action.date,
        },
        error: null,
      };
    case `${GET_BOOKING_SCHEMA}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Delete prenotazione
export const deleteBookingResponse = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${DELETE_BOOKING}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${DELETE_BOOKING}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${DELETE_BOOKING}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case RESET_DELETE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const initialStateBooking = {
  loading: false,
  loaded: false,
  result: null,
  error: null,
};

/* Prenotazione results
 * ADD - POST
 * PRENOTAZIONE - GET
 * RESET RESULT
 */
export const prenotazione = (state = initialStateBooking, action = {}) => {
  switch (action.type) {
    case RESET_PRENOTAZIONE:
      return {
        ...initialStateBooking,
      };
    case `${ADD_BOOKING}_PENDING`:
    case `${GET_PRENOTAZIONE}_PENDING`:
      return {
        ...state,
        loading: true,
        laoded: false,
        error: null,
      };
    case `${ADD_BOOKING}_SUCCESS`:
    case `${GET_PRENOTAZIONE}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${ADD_BOOKING}_FAIL`:
    case `${GET_PRENOTAZIONE}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Get prenotazione schema
export const vocOreList = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_VOC_ORE}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_VOC_ORE}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_VOC_ORE}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const vocBookingTypes = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_VOC_BOOKING_TYPES}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_VOC_BOOKING_TYPES}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_VOC_BOOKING_TYPES}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const bookingMove = (state = {}, action = {}) => {
  switch (action.type) {
    case RESET_MOVE_BOOKING:
      return {
        ...state,
        result: null,
        loading: false,
        loaded: false,
        error: null,
      };
    case `${MOVE_BOOKING}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${MOVE_BOOKING}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        // result: action.result,
        error: null,
      };
    case `${MOVE_BOOKING}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const addVacation = (state = initialStateBooking, action = {}) => {
  switch (action.type) {
    case RESET_ADD_VACATION:
      return {
        ...state,
        result: null,
        loading: false,
        loaded: false,
        error: null,
      };
    case `${ADD_VACATION}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${ADD_VACATION}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${ADD_VACATION}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const bookingReminder = (state = initialStateBooking, action = {}) => {
  switch (action.type) {
    case BOOKING_RESET_REMINDER: {
      return {
        ...state,
        result: null,
        loading: false,
        loaded: false,
        error: null,
      };
    }
    case `${BOOKING_REMINDER}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${BOOKING_REMINDER}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${BOOKING_REMINDER}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const updateBooking = (state = initialStateBooking, action = {}) => {
  switch (action.type) {
    case `${UPDATE_BOOKING}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${UPDATE_BOOKING}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${UPDATE_BOOKING}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case RESET_UPDATE_BOOKING: {
      return {
        ...state,
        result: null,
        loading: false,
        loaded: false,
        error: null,
      };
    }
    default:
      return state;
  }
};
